var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02075 1.11111C5.78672 1.11111 6.40964 1.73403 6.40964 2.5C6.40964 3.26597 5.78672 3.88889 5.02075 3.88889C4.25478 3.88889 3.63186 3.26597 3.63186 2.5C3.63186 1.73403 4.25478 1.11111 5.02075 1.11111ZM5.02075 0C3.6402 0 2.52075 1.11944 2.52075 2.5C2.52075 3.88056 3.6402 5 5.02075 5C6.40131 5 7.52075 3.88056 7.52075 2.5C7.52075 1.11944 6.40131 0 5.02075 0Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02075 6.42361C6.99263 6.42361 8.59714 8.02813 8.59714 10H9.70825C9.70825 7.41111 7.60964 5.3125 5.02075 5.3125C2.43186 5.3125 0.333252 7.41111 0.333252 10H1.44436C1.44436 8.02813 3.04888 6.42361 5.02075 6.42361Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.84d979d93d30e440757ec23938c4b5ae.svg";
export { ForwardRef as ReactComponent };